import {Notification, Message, MessageBox,Loading} from 'element-ui'
import {isFunction} from './utils'

let message = {
    info(opts){//消息提示
        let o = Object.assign({
            title: '提示',
            message: '',
            position: 'bottom-right',
            duration: 3000,
            type:'info'
        },opts);
        Notification(o);
    },
    warning(opts){//验证提示
        let o = Object.assign({
            title: '提示',
            message: '',
            showClose: true,
            duration:2000
        },opts);
        Message(o);
    },
    confirm(option,opts){//confirm框
        let o = Object.assign({
            confirmButtonText: '确定',
            cancelButtonText: '取消'
        },opts);
        MessageBox.confirm(option.message || '', option.tit || '确认', o).then(() => {
            if(isFunction(option.ok)) option.ok();
        }).catch(() => {
            if(isFunction(option.cancel)) option.cancel();
        });
    },
    loading(text){
        let msg = text || '正在加载中，请稍后...';
        let loading = Loading.service({
            lock: false,
            fullscreen:true,
            text: msg,
            spinner: 'loadingcss',
            background: 'rgba(0, 0, 0, 0.3)'
        });
        setTimeout(()=>{
            let objDom = document.getElementsByClassName('loadingcss'),
            parentDom = document.getElementsByClassName('el-loading-spinner'),
            aDom = document.createElement('a');
            aDom.className = 'el-icon-close';
            if(objDom.length > 0){
                parentDom[0].insertBefore(aDom,objDom[0]);
                aDom.onclick = function(){
                    loading.close();
                }
            }
        },100);
        
            
        return loading;
    }
}

export default message



// WEBPACK FOOTER //
// ./src/common/utils/message.js